import client from '../../../ConnectionManager/apolloClient';
import { user as userQuery } from './user.gql';

export const getUser = async () => {
  const result = await client.query({
    query: userQuery,
    errorPolicy: 'all',
  });
  return result;
};
